import { NavBar, Form, Button, Input, DatePicker, Selector, Toast } from 'antd-mobile'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import '../../styles/pages/game-form.css'
import { useLocation } from 'react-router-dom'
import moment from "moment";
import API_ROUTES from '../../api';
import axios from 'axios';

// 编辑页使用与创建页相同的选项值；接口的数字统一转为字符串后再回填 Selector。
const selectorValue = value => value === null || value === undefined ? [] : [String(value)];
const gameFormValues = game => ({
    gameName: game?.gameName || '',
    gameRemark: game?.gameRemark || '',
    startTime: game?.matchTime ? moment(game.matchTime).toDate() : undefined,
    gameType: selectorValue(game?.gameType),
    playerNum: selectorValue(game?.typeInfo),
    course: selectorValue(game?.gameCourse),
});

const LOCATION_PRESETS = [
    { label: '📍 华西东区', value: '四川大学华西校区东区-足球场' },
    { label: '📍 三分球场', value: '高新区三分足球场' },
];


export default function GameUpdate() {

    const location = useLocation();
    const routeGame = location.state?.gameDetail;
    const gameId = routeGame?.id || new URLSearchParams(location.search).get('gameId');
    const [gameDetail, setGameDetail] = useState(routeGame);
    const [form] = Form.useForm();
    const [buttomLoading, setButtomLoading] = useState(false)
    const [detailsLoading, setDetailsLoading] = useState(Boolean(gameId));
    const [detailsReady, setDetailsReady] = useState(false);
    const userInfo = localStorage.getItem("memberInfo");
    const memberInfo = userInfo ? JSON.parse(userInfo) : null;
    const [lngPos, setLngPos] = useState(routeGame?.lng);
    const [latPos, setLatPos] = useState(routeGame?.lat);
    const [position, setPosition] = useState(routeGame?.address || '');

    useEffect(() => {
        if (!gameId) return;
        // 每次进入编辑页都读取当前比赛，避免跳转时缓存的选项覆盖最新配置。
        axios.get(API_ROUTES.game_info, { params: { id: gameId } })
            .then(response => {
                if (response.data.code !== 200 || !response.data.data) {
                    Toast.show({ icon: 'fail', content: response.data.msg || '比赛信息加载失败' });
                    return;
                }
                const currentGame = response.data.data;
                setGameDetail(currentGame);
                form.setFieldsValue(gameFormValues(currentGame));
                setPosition(currentGame.address || '');
                setLatPos(currentGame.lat);
                setLngPos(currentGame.lng);
                setDetailsReady(true);
            })
            .catch(() => Toast.show({ icon: 'fail', content: '比赛信息加载失败，请刷新页面重试' }))
            .finally(() => setDetailsLoading(false));
    }, [form, gameId]);

    const createGamefunc = (values) => {
        // 详情未刷新成功时不使用旧的路由缓存提交，避免覆盖当前比赛配置。
        if (!detailsReady || !gameDetail?.id || !memberInfo?.id || !position.trim()) {
            Toast.show({ icon: 'fail', content: '请确认比赛、登录状态和球场位置' });
            return;
        }
        const matchTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');
        Toast.show({ icon: 'loading' });
        setButtomLoading(true)
        axios.post(API_ROUTES.game_updateGameInfo, {
            gameId: gameDetail.id,
            memberId: memberInfo.id,
            matchTime: matchTime,
            address: position,
            gameName: values?.gameName,
            gameRemark: values?.gameRemark ?? '',
            // 未修改的选项不提交，避免仅编辑名称时重新清空双方阵容。
            type: Number(values?.playerNum?.[0]) !== Number(gameDetail.typeInfo) ? Number(values?.playerNum?.[0]) : null,
            gameCourse: Number(values?.course?.[0]) !== Number(gameDetail.gameCourse) ? Number(values?.course?.[0]) : null,
            gameType: Number(values?.gameType?.[0]) !== Number(gameDetail.gameType) ? Number(values?.gameType?.[0]) : null,
            lat: latPos,
            lng: lngPos
        }, {
            headers: { "Authorization": memberInfo.id }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '修改成功！',
                        icon: 'success',
                        afterClose: () => window.history.back(),
                    })
                } else {
                    Toast.show({ content: response.data.msg, icon: 'fail' })
                }
            })
            .catch(function (error) {
                Toast.show({ content: '修改失败,请重试!', icon: 'fail' })
            })
            .finally(() => setButtomLoading(false));
    }

    const datePickerRef = useRef();
    const handleDatePickerClick = () => datePickerRef.current?.open();

    return (
        <div className="game-form-page game-form-page--update game-form-container has-unified-nav">
            <NavBar className="unified-navbar fixed" onBack={() => window.history.back()}>
                修改比赛信息
            </NavBar>

            <div className="form-section-header">
                <span className="title">修正记录</span>
            </div>

            <Form
                form={form}
                layout='vertical'
                className="game-form-premium"
                name='form'
                onFinish={(values) => createGamefunc(values)}
                initialValues={gameFormValues(gameDetail)}
                footer={
                    <div className="form-footer-premium">
                        <Button
                            type='submit'
                            className="submit-btn-premium"
                            loading={buttomLoading || detailsLoading}
                            disabled={!detailsReady || detailsLoading}
                        >
                            确认应用修改
                        </Button>
                    </div>
                }
            >
                <Form.Item
                    name='gameName'
                    label='赛事全称'
                    rules={[{ required: true, message: '请输入赛事名称' }]}
                >
                    <Input placeholder='修改赛事名称' />
                </Form.Item>

                <Form.Item
                    name='gameRemark'
                    label='赛事备注'
                >
                    <Input placeholder='备注新通知或规则更变...' />
                </Form.Item>

                <Form.Item
                    name='gameType'
                    label='赛事性质'
                    className="nature-selector"
                    rules={[{ required: true, message: '请选择比赛性质' }]}
                >
                    {/* 年会赛由活动创建，普通比赛不能改成无活动归属的年会赛。 */}
                    <Selector
                        columns={2}
                        disabled={Number(gameDetail?.gameType) === 4}
                        options={[
                            { label: '内讧赛', value: '3' },
                            { label: '友谊赛', value: '1' },
                            { label: '训练赛', value: '5' },
                            { label: '活动赛', value: '2' },
                            ...(Number(gameDetail?.gameType) === 4 ? [{ label: '年会赛', value: '4' }] : []),
                        ]}
                    />
                </Form.Item>

                <Form.Item
                    name='playerNum'
                    label='对抗人数 (每队)'
                    className="mode-selector"
                    help='预计规模，不限制最终签到人数'
                    rules={[{ required: true, message: '请选择对抗人数' }]}
                >
                    <Selector
                        columns={3}
                        options={[
                            { label: '8:8', value: '1' },
                            { label: '9:9', value: '4' },
                            { label: '11:11', value: '2' },
                            { label: '12:12', value: '3' },
                            { label: '待定', value: '0' },
                        ]}
                    />
                </Form.Item>

                <Form.Item
                    name='course'
                    label='赛程时长'
                    className="course-selector"
                    rules={[{ required: true, message: '请选择比赛节数' }]}
                >
                    <Selector
                        columns={2}
                        options={[
                            { label: '单节制', value: '1' },
                            { label: '两节制', value: '2' },
                            { label: '三节制', value: '3' },
                            // 修改比赛信息时也允许选择四节，保持与创建页一致。
                            { label: '四节制', value: '4' },
                        ]}
                    />
                </Form.Item>

                <Form.Item 
                    label='球场位置与标注' 
                    required 
                    help='修正比赛进行的球场名称'
                >
                    <Input 
                        placeholder="请输入新的球场地点..." 
                        value={position}
                        onChange={val => setPosition(val)}
                    />

                    <div className="location-preset-selector">
                        <Selector
                            columns={2}
                            options={LOCATION_PRESETS}
                            value={LOCATION_PRESETS.some(item => item.value === position) ? [position] : []}
                            onChange={(arr) => {
                                if (arr.length) {
                                    setPosition(arr[0])
                                    if (arr[0].includes('华西')) {
                                        setLatPos(30.64728)
                                        setLngPos(104.0774)
                                    }
                                }
                            }}
                        />
                    </div>
                </Form.Item>

                <Form.Item
                    name='startTime'
                    label='开赛日程'
                    trigger='onConfirm'
                    onClick={handleDatePickerClick}
                    rules={[{ required: true, message: '请选择比赛日期' }]}
                >
                    <DatePicker
                        ref={datePickerRef}
                        precision='minute'
                        title='修正比赛日程'
                        mode="date"
                        renderLabel={useCallback((type, data) => {
                            switch (type) {
                                case 'year': return data + '年';
                                case 'month': return data + '月';
                                case 'day': return data + '日 ';
                                case 'hour': return data + '时';
                                case 'minute': return data + '分';
                                default: return data;
                            }
                        }, [])}
                        // 开赛分钟与创建页一致，只允许选择整点及每隔十五分钟。
                        filter={{ minute: (val) => val % 15 === 0 }}
                    >
                        {(value) =>
                            value ? (
                                <div className="adm-date-picker-value">
                                    📅 {moment(value).format('YYYY-MM-DD')} <span className="game-form-date-time">⏰ {moment(value).format('HH:mm')}</span>
                                </div>
                            ) : <div className="adm-date-picker-value adm-date-picker-value--placeholder">请点击选择日期</div>
                        }
                    </DatePicker>
                </Form.Item>
            </Form>
        </div>
    )
}
